module.exports = __webpack_public_path__ + "02242164817143381123f859e7a75a1d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/quizzes-passed.png
// module id = 292
// module chunks = 0